import { render, staticRenderFns } from "./tabelaProdutos.vue?vue&type=template&id=1acd2225"
import script from "./tabelaProdutos.vue?vue&type=script&lang=js"
export * from "./tabelaProdutos.vue?vue&type=script&lang=js"
import style0 from "./tabelaProdutos.vue?vue&type=style&index=0&id=1acd2225&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports